import React, { useState } from "react";
import { Box, Button, Container, Typography, Paper, Alert, Snackbar } from "@mui/material";
import { Add } from "@mui/icons-material";
import TeamMembersTable from "./TeamMembersTable";
import TeamMemberModal from "./TeamMemberModal";
import SideNavbar from "../../../components/sideNavbar";
import Header from "../../../components/header";

const TeamMembers = () => {
    const [openModal, setOpenModal] = useState(false);
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    const [membersCount, setMembersCount] = useState(0);
    const [showLimitWarning, setShowLimitWarning] = useState(false);
    const clientId = localStorage.getItem("userId");
    const userRole = localStorage.getItem("userRole");

    const handleMembersCountChange = (count) => {
        setMembersCount(count);
    };

    const handleOpenModal = () => {
        if (membersCount >= 8) {
            setShowLimitWarning(true);
            return;
        }
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const handleSuccess = () => {
        setRefreshTrigger((prev) => prev + 1);
    };

    return (
        <Box>
            <Box
                sx={{
                    ml: { xs: "0px", md: "280px" },
                }}
            >
                <SideNavbar />

                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        pl: 0,
                        pr: 0,
                    }}
                >
                    <Container maxWidth="xl" sx={{ py: 3 }}>
                        <Box sx={{ p: 0, mb: 3 }}>
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                }}
                            >
                                <Box>
                                    <Typography variant="body1" fontWeight={600} gutterBottom>
                                        Team Member Management
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        Manage your team members who can login and assist with workspace tasks.
                                    </Typography>
                                </Box>
                                {userRole !== "viewer" && (
                                    <Button
                                        variant="contained"
                                        startIcon={<Add />}
                                        onClick={handleOpenModal}
                                        sx={{
                                            borderRadius: "22px",
                                            bgcolor: "#6366f1",
                                            "&:hover": { bgcolor: "#4f46e5" },
                                            textTransform: "capitalize",
                                            px: 3,
                                        }}
                                    >
                                        Add Team Member
                                    </Button>
                                )}
                            </Box>
                        </Box>

                        {/* Team Members Table */}
                        <TeamMembersTable
                            refreshTrigger={refreshTrigger}
                            onMembersCountChange={handleMembersCountChange}
                        />

                        {/* Add Team Member Modal */}
                        <TeamMemberModal
                            open={openModal}
                            onClose={handleCloseModal}
                            clientId={clientId}
                            onSuccess={handleSuccess}
                        />

                        <Snackbar
                            open={showLimitWarning}
                            autoHideDuration={4000}
                            onClose={() => setShowLimitWarning(false)}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                        >
                            <Alert
                                onClose={() => setShowLimitWarning(false)}
                                severity="warning"
                                variant="filled"
                                sx={{ width: '100%', borderRadius: '12px', fontWeight: 600 }}
                            >
                                Limit reached! Please contact admin to add more than 8 members.
                            </Alert>
                        </Snackbar>
                    </Container>
                </Box>
            </Box>
        </Box>
    );
};

export default TeamMembers;
